import clientesStore from "./store/clientes";
import regrasDescontoProduto from "./regras_desconto";

function atualizarDadosProduto(context) {
  const vctoInformado =
    context.getters.getParcelas[context.getters.getParcelas.length - 1];

  context.state.produtos.forEach((produto) => {
    produto.qtde = 0;
    produto.percdesconto = 0;
    produto.valordesconto = 0;
    produto.valorfrete = 0;
    produto.valorliqfrete = 0;
    produto.vlrunitcomfrete = 0;
    produto.valortotalitem = 0;
    produto.valorcalclista = 0;
    produto.saldofutura = 0;
    produto.qtdepedido = 0;
    produto.precisaretirar = 0;
    produto.permitecontrato = true;
    produto.msgbloqcontrato = "";
    produto.comissaomax = 0;
    produto.comissaoperc = 0;
    produto.maxdesconto = 0;
    produto.mindesconto = 0;
    produto.perctributaforauf = 0;
    produto.perctributadiferimento = 0;
    produto.vlrsemencargos = produto.precolista;
    produto.vlrunitario = 0;
    produto.preco = produto.precolista;
    produto.numparcelas = vctoInformado.parc;
    produto.disponivelretirada = 0;
    produto.erros = [];

    if (produto.qtdemax == 0)
      produto.qtdemax = context.getters.getTipoPedidoSelec.qtdemax;

    /*Alimentar informação do saldo da futura*/
    var indProdAberto = clientesStore.state.produtosEmAberto.findIndex(
      (pa) => pa.id == produto.id && pa.filial == context.getters.getFilialSelecionada.filial
    );
    if (indProdAberto >= 0) {
      produto.saldofutura =
        clientesStore.state.produtosEmAberto[indProdAberto].saldofutura;
      produto.qtdepedido =
        clientesStore.state.produtosEmAberto[indProdAberto].qtdepedido;
      produto.precisaretirar =
        clientesStore.state.produtosEmAberto[indProdAberto].precisaretirar;
      produto.permitecontrato =
        clientesStore.state.produtosEmAberto[indProdAberto].permitecontrato;
      produto.msgbloqcontrato =
        clientesStore.state.produtosEmAberto[indProdAberto].msgbloqcontrato;

      if (context.getters.getTipoPedidoSelec.remessa) {
        produto.disponivelretirada =
          clientesStore.state.produtosEmAberto[indProdAberto].saldoremessas;
        if (produto.disponivelretirada > 0) {
          produto.qtdemin = 1;
          if (produto.disponivelretirada > produto.qtdemax)
            produto.qtdemax = produto.disponivelretirada;
        }
      }
    }    

    if (
      context.getters.getTipoPedidoSelec.contrato &&
      context.getters.getCondicaoSelecionada.acrescimoperc > 0
    ) {
      produto.acrescimoperc =
        context.getters.getCondicaoSelecionada.acrescimoperc;
    }

    if (vctoInformado.avista) {
      produto.acrescimoperc = 0;
    }

    /*Atualizar informações de percentual de comissão*/
    if (context.state.novopedido.cliente.vendedor.recebecomissao) {
      produto.comissaomax =
        context.state.novopedido.cliente.vendedor.percvendas;
    }

    /*Aplica os cálculos no preço baseado nas condições do vendedor*/
    if (context.state.novopedido.cliente.vendedor.calcular) {
      if (context.state.novopedido.cliente.vendedor.percacresc > 0) {
        produto.preco =
          produto.preco *
          ((100 + context.state.novopedido.cliente.vendedor.percacresc) / 100);

        produto.precolista = produto.preco;
      }
      if (context.state.novopedido.cliente.vendedor.percdesconto > 0) {
        produto.preco =
          produto.preco *
          ((100 - context.state.novopedido.cliente.vendedor.percdesconto) /
            100);
        produto.precolista = produto.preco;
      }
    }

    /*Verifico se o item tem antecipação*/
    if (vctoInformado.avista && produto.antecipacao.length > 0) {
      var indicePercAntec = produto.antecipacao.findIndex(
        (a) => a.data == vctoInformado.vcto
      );
      if (indicePercAntec >= 0) {
        produto.preco =
          (produto.preco * 100) /
          (100 + produto.antecipacao[indicePercAntec].percantec);
      }
      produto.vlrsemencargos = produto.preco;
    }

    /*ver tributações*/
    var tributacaoSelec = null;
    if (
      context.getters.getFilialSelecionada.uf !=
      context.state.novopedido.cliente.uf
    ) {
      var posTributaForaUf = produto.tributacoes.findIndex(
        (p) => p.cfop == context.getters.getFilialSelecionada.cfopforauf
      );

      if (posTributaForaUf >= 0) {
        tributacaoSelec = produto.tributacoes[posTributaForaUf];
        produto.perctributaforauf = tributacaoSelec.percicmscalc;
      } else {
        produto.erros.push(
          `Produto sem tributação para a cfop ${context.getters.getFilialSelecionada.cfopforauf}`
        );
      }
    }

    /*Ver diferimento*/
    if (context.state.novopedido.cliente.diferimento) {
      var posCfopDifer = produto.tributacoes.findIndex(
        (p) => p.cfop == context.getters.getFilialSelecionada.cfopmesmauf
      );
      if (posCfopDifer >= 0) {
        var cfopDiferimento = produto.tributacoes[posCfopDifer].cfopdiferimento;
        var posTributaDifer = produto.tributacoes.findIndex(
          (p) => p.cfop == cfopDiferimento
        );

        if (posTributaDifer >= 0) {
          var tributacaoDiferimento = produto.tributacoes[posTributaDifer];
          produto.perctributadiferimento = tributacaoDiferimento.percicmscalc;
        }
      }
    }

    /*Ver Desconto comissão e Máx desconto produto*/
    if (context.state.config.regrasdesconto.length > 0) {
      regrasDescontoProduto(context, produto, vctoInformado);
    }

    /*Pedidos de bonificação é com preço de custo*/
    if (context.getters.getTipoPedidoSelec.bonificacao) {
      var posPrecoCusto = produto.custos.findIndex(
        (c) => c.filial == context.getters.getFilialSelecionada.filial
      );
      if (posPrecoCusto < 0) {
        posPrecoCusto = produto.custos.findIndex((c) => c.filial == 0);
      }
      if (posPrecoCusto >= 0) {
        produto.preco = produto.custos[posPrecoCusto].preco;
        produto.maxdesconto = 0;
        produto.mindesconto = 0;
        produto.comissaomax = 0;
        produto.acrescimoperc = 0;
      } else {
        produto.preco = 0;
      }
    }

    /*Validação Pedidos Contrato*/
    if (context.getters.getTipoPedidoSelec.contrato) {
      if (!produto.permitecontrato) {
        produto.erros.push(produto.msgbloqcontrato);
      }
    } else if (context.getters.getTipoPedidoSelec.remessa) {
      produto.mindesconto = 0;
      produto.comissaomax = 0;
    }

    if (produto.preco <= 0) {
      produto.erros.push("Produto sem preço de lista");
    }

    produto.comissaoperc = produto.comissaomax;
  });
}

export default atualizarDadosProduto;
